export class ClouddnsWebsocketsState {
  reconnecting: boolean;

  constructor() {
    this.reconnecting = false;
  }
}
